module.exports = __webpack_public_path__ + "static/Portfolio_example-7ffe4c20280905db269ce3a201fe6a84.svg";